import axios from 'axios';

export const getOrganizations = async (page) => {
  const pageParam = page ? `?page=${page}` : '';
  return axios.get(`core/organizations/${pageParam}`);
};

export const getOrganizationById = async (id) => {
  return axios.get(`core/organizations/${id}/`);
};

export const createOrganization = async (data) => {
  return axios.post('core/organizations/', data);
};

export const updateOrganization = async (id, data) => {
  return axios.put(`core/organizations/${id}/`, data);
};

export const patchOrganization = async (id, data) => {
  return axios.patch(`core/organizations/${id}/`, data);
};

export const deleteOrganization = async (id) => {
  return axios.delete(`core/organizations/${id}/`);
};

export const getOrganizationsRestricted = async () => {
  return axios.get('core/organizations/restricted/');
};
